import styled from '@emotion/styled';
import { Button } from 'components/ui';
import { useNavigate } from 'react-router-dom';
import NoLogInPageWeb from 'components/layout/NoLogOutPageWeb';

import { selectedImagesAtom } from "components/pages/Onboarding/onboardingAtom";
import { useAtom } from "jotai"
import { CheckOutlined } from "@ant-design/icons";
import ReactGA from "react-ga4";

const Elem:React.FC<any> = () => {
  const [ selectedImage, setSelectedImage ] = useAtom(selectedImagesAtom);
  const navigate = useNavigate();

  const handleGotoDetail = () => {
    navigate('/onboarding/2/detail');

    ReactGA.event({
      "category" : "Button",
      "action" : "Click",
      "label": "go to input detail modal"
    })
  };

  return (
    <Background>
      <ModalContainer>
        <NoLogInPageWeb disable={false}>
        <ContextContainer>
          <TextContainer>
            <SmallText>전송 완료</SmallText>
            <BigText className="tiny">구독을 체험할 수 있는</BigText>
            <BigText className="Bold">5장 인화가 준비됐어요.</BigText>
            <SmallText className="small">신청 완료하면 1~2일 내 받아볼 수 있어요.</SmallText>
            <SmallText className="small">부담없이 체험 후 구독 결정하세요.</SmallText>
          </TextContainer>
          <PhotoContainer>
            <DetailPhotoContainer>
              <SmallPhotoWrapper>
                <ContentsContainer>
                  <CheckContainer>
                    <CheckOutlined/>
                  </CheckContainer>
                  <TinyText>전송완료</TinyText>
                </ContentsContainer>
              </SmallPhotoWrapper>
              <SmallPhotoWrapper>
                {selectedImage.length > 0 && (
                  <SelectPhotoWrapper src={selectedImage[0]} />
                )}
              </SmallPhotoWrapper>
            </DetailPhotoContainer>
            <DetailPhotoContainer>
                <SmallPhotoWrapper>
                  {selectedImage.length > 1 && (
                    <SelectPhotoWrapper src={selectedImage[1]} />
                  )}
                </SmallPhotoWrapper>
                <SmallPhotoWrapper>
                  {selectedImage.length > 2 && (
                    <SelectPhotoWrapper src={selectedImage[2]} />
                  )}
                </SmallPhotoWrapper>
              </DetailPhotoContainer>
            <DetailPhotoContainer>
              <SmallPhotoWrapper>
                {selectedImage.length > 3 && (
                  <SelectPhotoWrapper src={selectedImage[3]} />
                )}
              </SmallPhotoWrapper>
              <SmallPhotoWrapper>
                {selectedImage.length > 4 && (
                  <SelectPhotoWrapper src={selectedImage[4]} />
                )}
              </SmallPhotoWrapper>
            </DetailPhotoContainer>
          </PhotoContainer>
          <ToastContainser>
          </ToastContainser>
          <ButtonWrapper>
            <Button
              layoutVariant="contained"
              variant="default"
              onClick={handleGotoDetail}
              expand
            >배송 정보 입력</Button>
          </ButtonWrapper>
        </ContextContainer>
        </NoLogInPageWeb>
      </ModalContainer>
    </Background>
  )
};

export default Elem;

const Background = styled.div`
  position:fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: white;
  z-index: 0;
`
const ModalContainer = styled.div`
  position: fixed;
  left: 50%;
  top: 50%;
  overflow: scroll;
  transform: translate(-50%, -50%);
  /* width: 1024px; */
  width: 100%;
  height: 100%;
  background-color: white;
  text-align: center;
  display: flex;
  flex-direction: column;
  z-index: 1;
`;

const ContextContainer = styled.div`
  max-width: 344px;
  height: 70%;
  margin: 65px auto;
  display: flex;
  flex-direction: column;
`
const TextContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: baseline;
`
const BigText = styled.div`
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 400;
  font-size: 23px;
  line-height: 133%;
  color: #000000;

  &.tiny{
    font-weight: lighter;
  }

  &.bold {
    font-weight: bold;
  }
`
const SmallText = styled.div`
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  color: #141414;
  &.first {
    margin-top: 17px;
    
  }
  &.small{
    margin-top: 5px;
color: rgba(117, 117, 117, 1);
  }
`

const PhotoContainer = styled.div`
  width: 304px;
  /* height: 100%; */
  min-height: 300px;
  margin: 67px auto 0;
  display: flex;
  flex-direction: column;
`;
const DetailPhotoContainer = styled.div`
  width: 100%;
  height: 150px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
const SmallPhotoWrapper = styled.div`
  width: 48%;
  height: 93%;
  display: flex;
  min-height: 95px;
`
const ButtonWrapper = styled.div`
  width: 300px;
  height: 52px;
  margin: 150px auto 0;
`;
const SelectPhotoWrapper = styled.img`
  width: 100%;
  height: 100%;
  object-fit:cover;
`;
const ContentsContainer = styled.div`
  width: 38px;
  height: 34px;
  margin: 30px auto 0 ;
  display: flex;
  flex-direction: column;
`;
const TinyText = styled.div`
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 100%;
  text-align: center;
  color: #141414;
  margin-top: 12px;
`
const CheckContainer = styled.div`
  width: 15px;
  height: 12px;
  margin: 0 auto;
`;
const ToastContainser = styled.div`
  width: 300px;
  height: 43px;
  /* margin: 80px auto 0; */
  margin: 30px auto 0;
`;
